import { render, staticRenderFns } from "./goods-info.vue?vue&type=template&id=593ff4e2&scoped=true"
import script from "./goods-info.vue?vue&type=script&lang=js"
export * from "./goods-info.vue?vue&type=script&lang=js"
import style0 from "./goods-info.vue?vue&type=style&index=0&id=593ff4e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ff4e2",
  null
  
)

export default component.exports